import { GROUP_TOKEN_SEPARATOR } from "./consts";

export const buildGroupQueryKey = ({
  title,
  queryKey,
}: {
  title?: string;
  queryKey?: string;
}): string => normalizeGroupQueryKey(queryKey ?? title ?? "");

const normalizeGroupQueryKey = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const buildGroupSelectionToken = (
  groupKey: string,
  value: string
): string => `${groupKey}${GROUP_TOKEN_SEPARATOR}${value}`;

export const setParamValues = (
  params: URLSearchParams,
  paramName: string,
  values: string[]
): void => {
  params.delete(paramName);
  values.forEach((value) => params.append(paramName, value));
};
